import { Injectable, signal } from '@angular/core';
import { Entitlement, UserInfo } from '../locallogin/login-information.service';

@Injectable({
  providedIn: 'root',
})
export class EntitlementsService {
  private readonly _entitlements = signal<Entitlement[]>([]);
  private readonly _userInfo = signal<UserInfo | null>(null);
  private readonly _initialized = signal(false);
  private readonly _validatedAt = signal(0);

  readonly entitlements = this._entitlements.asReadonly();
  readonly userInfo = this._userInfo.asReadonly();
  readonly initialized = this._initialized.asReadonly();

  set(entitlements: Entitlement[], userInfo: UserInfo | null = null): void {
    this._entitlements.set(entitlements ?? []);
    this._userInfo.set(userInfo);
    this._initialized.set(true);
    this._validatedAt.set(Date.now());
  }

  /** Marks the session as freshly revalidated against the backend. */
  markValidated(): void {
    this._validatedAt.set(Date.now());
  }

  /** True when the cached session is older than the given TTL and must be rechecked. */
  needsRevalidation(ttlMs: number): boolean {
    return Date.now() - this._validatedAt() > ttlMs;
  }

  getAll(): Entitlement[] {
    return this._entitlements();
  }

  has(id: string): boolean {
    return this._entitlements().some((e) => e.id === id);
  }

  clear(): void {
    this._entitlements.set([]);
    this._userInfo.set(null);
    this._initialized.set(false);
    this._validatedAt.set(0);
  }
}
